<template>
    <v-dialog
            v-model="value"
            width="500"
    >
        <v-card>
            <v-card-title class="headline grey lighten-2">
               Upload-Endpunkt löschen
            </v-card-title>

            <v-card-text>
             Wollen Sie wirklich den Upload-Endpunkt {{ uploaded ? uploaded.name : '' }} endgültig löschen?<br/>
                <b>Dieser Vorgang kann nicht rückgängig gemacht werden!</b>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
                <v-btn
                        color="primary"
                        text
                        @click="close"
                >
                    Abbrechen
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn
                        color="primary"
                        text
                        @click="deleteEndpoint"
                >
                    Ja
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        name: "UploadDeleteConfirmation",
        props: ['value', 'uploaded'],
        methods: {
            close() {
                this.$emit('close')
            },
            deleteEndpoint () {
                this.$emit('delete')
            }
        }
    }
</script>

<style scoped>

</style>